import { render } from "./VideoController.vue?vue&type=template&id=2b9661d2&scoped=true"
import script from "./VideoController.vue?vue&type=script&lang=js"
export * from "./VideoController.vue?vue&type=script&lang=js"

import "./VideoController.vue?vue&type=style&index=0&id=2b9661d2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9661d2"]])

export default __exports__